import { IconBox } from "./IconBox";

export type IService = {
  header: string;
  description: string;
  icon: string;
};
const SERVICES: IService[] = [
  {
    header: "Customized Menus",
    description:
      "We work closely with each client to create a specialized menu featuring your favorite foods and cuisines to perfectly match your event's theme and satisfy your guests.",
    icon: "bi-gem",
  },
  {
    header: "Flexible Serving Options",
    description:
      "Our food trucks can provide buffet-style serving, plated individual meals, heavy hors d'oeuvres, or any combination to accommodate your event size and preferences.",
    icon: "bi-alt",
  },
  {
    header: "Full Event Planning",
    description:
      "In addition to providing exceptional food, we also offer comprehensive event planning services including coordination of rentals, staffing, decor, entertainment, and more. We can take the stress out of event planning!",
    icon: "bi-clipboard-data",
  },
];

export const WhyUsSection = () => (
  <section id="why-us" className="why-us section-bg">
    <div className="container" data-aos="fade-up">
      <div className="row gy-4">
        <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
          <div className="why-box">
            <h3>Why Choose 7Starr?</h3>
            <p>
              We provide classic fusion of American cuisine, southern comfort
              food, Caribbean spice, and European zest right to your door.
            </p>
            <div className="text-center">
              <a href="#about" className="more-btn">
                Learn More <i className="bx bx-chevron-right"></i>
              </a>
            </div>
          </div>
        </div>
        {/*  End Why Box  */}

        <div className="col-lg-8 d-flex align-items-center">
          <div className="row gy-4">
            {SERVICES.map((service) => (
              <IconBox {...service} />
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
